import React, { useState, useEffect, useCallback } from 'react';
import {
  getProdutos, createProduto, deleteProduto, getMovimentacoes,
  addEntrada, addSaida, isAuthenticated, logout, getUsuario, getResumo,
  getCustos, createCusto, deleteCusto,
  getClientes, createCliente, deleteCliente,
  criarPedido,
} from './api';
import LoginPage from './components/LoginPage';
import ProdutoForm from './components/ProdutoForm';
import TabelaProdutos from './components/TabelaProdutos';
import MovimentacaoModal from './components/MovimentacaoModal';
import Historico from './components/Historico';
import ResumoCards from './components/ResumoCards';
import RelatorioFinanceiro from './components/RelatorioFinanceiro';
import CustoForm from './components/CustoForm';
import TabelaCustos from './components/TabelaCustos';
import ClienteForm from './components/ClienteForm';
import TabelaClientes from './components/TabelaClientes';
import Toast from './components/Toast';
import ConfirmModal from './components/ConfirmModal';
import SearchableSelect from './components/SearchableSelect';

const NAV = [
  { key: 'inicio', icon: '🏠', label: 'Início' },
  { key: 'vender', icon: '🛒', label: 'Vender' },
  { key: 'estoque', icon: '📦', label: 'Estoque' },
  { key: 'clientes', icon: '👥', label: 'Clientes' },
  { key: 'relatorio', icon: '📊', label: 'Relatório' },
];

function VenderPage({ produtos, clientes, preSelected, onCreateCliente, onVenda, saving }) {
  const [cart, setCart] = useState([]);
  const [clienteId, setClienteId] = useState('');
  const [erro, setErro] = useState('');
  const [novoCliente, setNovoCliente] = useState('');
  const [showAddCliente, setShowAddCliente] = useState(false);

  useEffect(() => {
    if (preSelected && !cart.find(i => i.id === Number(preSelected))) {
      const p = produtos.find(x => x.id === Number(preSelected));
      if (p && p.quantidade > 0) setCart([{ id: p.id, nome: p.nome, preco: Number(p.preco), qtd: 1, max: p.quantidade }]);
    }
  }, [preSelected]);

  const addToCart = (p) => {
    if (p.quantidade <= 0) return;
    setErro('');
    const idx = cart.findIndex(i => i.id === p.id);
    if (idx >= 0) {
      if (cart[idx].qtd >= p.quantidade) { setErro(`Estoque máximo: ${p.quantidade}`); return; }
      const n = [...cart];
      n[idx] = { ...n[idx], qtd: n[idx].qtd + 1 };
      setCart(n);
    } else {
      setCart([...cart, { id: p.id, nome: p.nome, preco: Number(p.preco), qtd: 1, max: p.quantidade }]);
    }
  };

  const setItemQtd = (id, qtd) => {
    const item = cart.find(i => i.id === id);
    if (!item) return;
    const q = Math.max(0, Math.min(qtd, item.max));
    if (q === 0) setCart(cart.filter(i => i.id !== id));
    else setCart(cart.map(i => i.id === id ? { ...i, qtd: q } : i));
  };

  const total = cart.reduce((s, i) => s + i.preco * i.qtd, 0);
  const totalItens = cart.reduce((s, i) => s + i.qtd, 0);

  const handleAddCliente = (e) => {
    e.preventDefault();
    if (!novoCliente.trim()) return;
    onCreateCliente({ nome: novoCliente.trim() });
    setNovoCliente('');
    setShowAddCliente(false);
  };

  const handleSubmit = (e) => {
    e.preventDefault(); setErro('');
    if (cart.length === 0) { setErro('Adicione produtos ao pedido'); return; }
    onVenda({ cliente_id: clienteId ? Number(clienteId) : undefined, itens: cart.map(i => ({ produto_id: i.id, quantidade: i.qtd })) });
  };

  return (
    <form onSubmit={handleSubmit}>
      {erro && <div className="err">{erro}</div>}

      <span className="lbl">Produtos</span>
      {produtos.length === 0 ? (
        <div className="mt"><span className="mt-ico">📦</span>Nenhum produto cadastrado.</div>
      ) : (
        <div className="p-grid">
          {produtos.map(p => {
            const inCart = cart.find(i => i.id === p.id);
            const sem = p.quantidade <= 0;
            return (
              <div key={p.id} className={`p-chip ${inCart ? 'sel' : ''} ${sem ? 'dim' : ''}`}
                onClick={() => !sem && addToCart(p)}>
                <strong style={{ fontSize: 13 }}>{p.nome}</strong>
                <p>R$ {Number(p.preco).toFixed(2)} | {p.quantidade} un.</p>
                {inCart && <span className="bd bd-g" style={{ marginTop: 4, display: 'inline-block' }}>{inCart.qtd}x</span>}
              </div>
            );
          })}
        </div>
      )}

      {cart.length > 0 && (
        <>
          <span className="lbl">Carrinho</span>
          <div className="lst mb2">
            {cart.map(item => (
              <div key={item.id} className="it">
                <div className="it-main">
                  <strong style={{ fontSize: 13 }}>{item.nome}</strong>
                  <div style={{ fontSize: 12, color: 'var(--c4)' }}>R$ {item.preco.toFixed(2)} un.</div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', gap: 4, flexShrink: 0 }}>
                  <button type="button" className="btn btn3 btn-sm" style={{ width: 28, padding: 4 }}
                    onClick={() => setItemQtd(item.id, item.qtd - 1)}>−</button>
                  <span style={{ fontWeight: 700, minWidth: 24, textAlign: 'center', fontSize: 13 }}>{item.qtd}</span>
                  <button type="button" className="btn btn3 btn-sm" style={{ width: 28, padding: 4 }}
                    onClick={() => setItemQtd(item.id, item.qtd + 1)} disabled={item.qtd >= item.max}>+</button>
                  <span style={{ fontWeight: 600, fontSize: 13, marginLeft: 8, color: 'var(--g)', minWidth: 60, textAlign: 'right' }}>
                    R$ {(item.preco * item.qtd).toFixed(2)}
                  </span>
                </div>
              </div>
            ))}
          </div>
          <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 12, padding: '8px 12px', background: 'var(--g3)', borderRadius: 10 }}>
            <span style={{ fontSize: 13, fontWeight: 600 }}>{totalItens} un. em {cart.length} produto(s)</span>
            <strong style={{ fontSize: 18, color: 'var(--g)' }}>R$ {total.toFixed(2)}</strong>
          </div>
        </>
      )}

      <span className="lbl">Cliente (opcional)</span>
      {clientes.length === 0 && !showAddCliente ? (
        <button type="button" className="btn btn3 btn-sm" onClick={() => setShowAddCliente(true)} style={{ alignSelf: 'flex-start', marginBottom: 12 }}>
          + Cadastrar cliente
        </button>
      ) : showAddCliente ? (
        <div className="inp-r" style={{ marginBottom: 12 }}>
          <input className="inp" placeholder="Nome do cliente" value={novoCliente} onChange={e => setNovoCliente(e.target.value)} autoFocus />
          <button type="button" className="btn btn1 btn-sm" onClick={handleAddCliente}>OK</button>
          <button type="button" className="btn btn3 btn-sm" onClick={() => { setShowAddCliente(false); setNovoCliente(''); }}>x</button>
        </div>
      ) : (
        <div style={{ marginBottom: 12 }}>
          <SearchableSelect
            value={clienteId}
            placeholder="Sem cliente"
            options={clientes.map(c => ({ value: String(c.id), label: c.nome, sub: `${c.total_pedidos} ped.` }))}
            onChange={setClienteId}
            onAddNew={() => setShowAddCliente(true)}
          />
        </div>
      )}

      <button className="btn btn1 btn-lg" type="submit" disabled={cart.length === 0 || saving}>
        {saving ? 'Salvando...' : `Finalizar Pedido • R$ ${total.toFixed(2)}`}
      </button>
    </form>
  );
}

export default function App() {
  const [autenticado, setAutenticado] = useState(isAuthenticated());
  const [usuario, setUsuario] = useState(getUsuario());
  const [produtos, setProdutos] = useState([]);
  const [movimentacoes, setMovimentacoes] = useState([]);
  const [custos, setCustos] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [resumo, setResumo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [tab, setTab] = useState('inicio');
  const [showForm, setShowForm] = useState(false);
  const [showCustoForm, setShowCustoForm] = useState(false);
  const [showClienteForm, setShowClienteForm] = useState(false);
  const [movModal, setMovModal] = useState(null);
  const [preSelected, setPreSelected] = useState('');
  const [toast, setToast] = useState(null);
  const [confirm, setConfirm] = useState(null);

  const showToast = (msg, type = 'success') => setToast({ message: msg, type });
  const askConfirm = (title, message) => new Promise(resolve => {
    setConfirm({ title, message, onConfirm: () => { setConfirm(null); resolve(true); }, onCancel: () => { setConfirm(null); resolve(false); } });
  });

  const loadData = useCallback(async () => {
    setLoading(true);
    try {
      const hoje = new Date();
      const [p, m, r, c, cl] = await Promise.all([
        getProdutos(), getMovimentacoes(), getResumo(hoje.getMonth() + 1, hoje.getFullYear()), getCustos(), getClientes()]);
      setProdutos(p); setMovimentacoes(m); setResumo(r); setCustos(c); setClientes(cl);
    } catch (err) { if (err.message.includes('401') || err.message.includes('Token')) handleLogout(); }
    setLoading(false);
  }, []);

  useEffect(() => { if (autenticado) loadData(); }, [autenticado, loadData]);

  const handleLogin = (user) => { setUsuario(user); setAutenticado(true); };
  const handleLogout = () => { logout(); setAutenticado(false); setUsuario(null); };

  const doSave = async (fn, okMsg) => {
    setSaving(true);
    try { await fn(); showToast(okMsg); loadData(); }
    catch (err) { showToast(err.message, 'error'); }
    setSaving(false);
  };

  const switchTab = (key) => {
    setTab(key);
    setShowForm(false); setShowCustoForm(false); setShowClienteForm(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const lowStock = produtos.filter(p => p.quantidade > 0 && p.quantidade <= 3).length;

  if (!autenticado) return <LoginPage onLogin={handleLogin} />;

  if (loading) return (
    <div className="app">
      <div className="hdr"><div><h1>Marmitas Fit</h1></div></div>
      <div style={{ padding: 16 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginBottom: 16 }}>
          {[1,2,3,4].map(i => <div key={i} className="sk-sm" style={{ borderRadius: 10 }} />)}
        </div>
        <div className="sk">{ [1,2,3,4,5].map(i => <div key={i} className="sk-it" />) }</div>
      </div>
    </div>
  );

  const vendasRecentes = movimentacoes.filter(m => m.tipo === 'saida').slice(0, 5);

  return (
    <div className="app">
      <div className="hdr">
        <div><h1>Marmitas Fit</h1><div className="hdr-user">{usuario?.nome}</div></div>
        <button className="hdr-btn" onClick={handleLogout}>Sair</button>
      </div>

      {tab !== 'relatorio' && resumo && <ResumoCards resumo={resumo} />}

      <div className="pg" key={tab}>
        {tab === 'inicio' && (
          <>
            <div className="c">
              <div className="c-h"><span className="c-t">Ações rápidas</span></div>
              <div className="btn-g" style={{ flexDirection: 'column' }}>
                <button className="btn btn1" onClick={() => switchTab('vender')}>🛒 Nova Venda</button>
                <button className="btn btn3" onClick={() => { switchTab('estoque'); setShowForm(true); }}>📦 Novo Produto</button>
                <button className="btn btn3" onClick={() => { switchTab('clientes'); setShowClienteForm(true); }}>👥 Novo Cliente</button>
                <button className="btn btn3" onClick={() => { switchTab('custos'); setShowCustoForm(true); }}>🧾 Lançar Custo</button>
              </div>
            </div>
            {vendasRecentes.length > 0 && (
              <div className="c">
                <div className="c-h"><span className="c-t">Últimas vendas</span><button className="btn btn3 btn-sm" onClick={() => switchTab('relatorio')}>Relatório</button></div>
                <div className="lst">
                  {vendasRecentes.map(m => (
                    <div key={m.id} className="it">
                      <div className="it-main">
                        <strong style={{ fontSize: 13 }}>{m.produto_nome}</strong>
                        {m.cliente_nome && <span style={{ fontSize: 12, color: 'var(--c4)' }}> • {m.cliente_nome}</span>}
                      </div>
                      <div style={{ textAlign: 'right', flexShrink: 0 }}>
                        <span style={{ fontSize: 12, color: 'var(--c4)' }}>{new Date(m.data).toLocaleDateString('pt-BR')}</span>
                        <div style={{ fontWeight: 700, color: 'var(--g)', fontSize: 14 }}>R$ {(m.quantidade * m.preco_unitario).toFixed(2)}</div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
            {produtos.length > 0 && (
              <div className="c">
                <div className="c-h"><span className="c-t">Estoque</span><button className="btn btn3 btn-sm" onClick={() => switchTab('estoque')}>Ver tudo</button></div>
                <div className="lst">
                  {produtos.filter(p => p.quantidade > 0).slice(0, 5).map(p => (
                    <div key={p.id} className="it" onClick={() => { setPreSelected(String(p.id)); switchTab('vender'); }} style={{ cursor: 'pointer' }}>
                      <div className="it-main">
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <strong>{p.nome}</strong>
                          <span className={`bd ${p.quantidade <= 3 ? 'bd-r' : 'bd-g'}`}>{p.quantidade} un.</span>
                        </div>
                        <div style={{ fontSize: 12, color: 'var(--c4)', marginTop: 2 }}>R$ {Number(p.preco).toFixed(2)} | Margem R$ {(Number(p.preco) - Number(p.preco_custo)).toFixed(2)}</div>
                      </div>
                      <button className="btn btn2 btn-sm" onClick={e => { e.stopPropagation(); setPreSelected(String(p.id)); switchTab('vender'); }}>Vender</button>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </>
        )}

        {tab === 'estoque' && (
          <>
            <div className="c">
              <div className="c-h"><span className="c-t">Produtos</span><button className="btn btn1 btn-sm" onClick={() => setShowForm(!showForm)} disabled={saving}>{showForm ? 'Fechar' : '+ Novo'}</button></div>
              {showForm && <div className="mb2"><ProdutoForm onSubmit={async (data) => { await doSave(() => createProduto(data), 'Produto cadastrado!'); setShowForm(false); }} onCancel={() => setShowForm(false)} /></div>}
              <TabelaProdutos produtos={produtos}
                onEntrada={(p) => setMovModal({ produto: p, tipo: 'entrada' })}
                onSaida={(p) => { setPreSelected(String(p.id)); switchTab('vender'); }}
                onDelete={async (p) => { if (await askConfirm('Remover', `Excluir "${p.nome}"?`)) { await doSave(() => deleteProduto(p.id), 'Produto removido'); } }} />
            </div>
            <div className="c"><span className="c-t">Histórico</span><Historico movimentacoes={movimentacoes} /></div>
          </>
        )}

        {tab === 'vender' && (
          <div className="c"><div className="c-h"><span className="c-t">Nova Venda</span></div>
            <VenderPage produtos={produtos} clientes={clientes} preSelected={preSelected} saving={saving}
              onCreateCliente={async (data) => { const c = await createCliente(data); setClientes(prev => [...prev, { ...c, total_pedidos: 0 }]); showToast('Cliente cadastrado!'); }}
              onVenda={async (payload) => {
                await doSave(async () => {
                  await criarPedido(payload);
                  setPreSelected(''); switchTab('inicio');
                }, `Pedido finalizado! ${payload.itens.length} produto(s)`);
              }} />
          </div>
        )}

        {tab === 'clientes' && (
          <div className="c">
            <div className="c-h"><span className="c-t">Clientes</span><button className="btn btn1 btn-sm" onClick={() => setShowClienteForm(!showClienteForm)} disabled={saving}>{showClienteForm ? 'Fechar' : '+ Novo'}</button></div>
            {showClienteForm && <div className="mb2"><ClienteForm onSubmit={async (data) => { await doSave(() => createCliente(data), 'Cliente cadastrado!'); setShowClienteForm(false); }} onCancel={() => setShowClienteForm(false)} /></div>}
            <TabelaClientes clientes={clientes} onDelete={async (c) => { if (await askConfirm('Remover', `Excluir "${c.nome}"?`)) { await doSave(() => deleteCliente(c.id), 'Cliente removido'); } }} />
          </div>
        )}

        {tab === 'custos' && (
          <div className="c">
            <div className="c-h"><span className="c-t">Custos e Despesas</span><button className="btn btn1 btn-sm" onClick={() => setShowCustoForm(!showCustoForm)} disabled={saving}>{showCustoForm ? 'Fechar' : '+ Novo'}</button></div>
            {showCustoForm && <div className="mb2"><CustoForm onSubmit={async (data) => { await doSave(() => createCusto(data), 'Custo lançado!'); setShowCustoForm(false); }} onCancel={() => setShowCustoForm(false)} /></div>}
            <TabelaCustos custos={custos} onDelete={async (c) => { if (await askConfirm('Remover', `Excluir "${c.descricao}"?`)) { await doSave(() => deleteCusto(c.id), 'Custo removido'); } }} />
          </div>
        )}

        {tab === 'relatorio' && (
          <div className="c"><div className="c-h"><span className="c-t">Relatório Financeiro</span></div><RelatorioFinanceiro /></div>
        )}
      </div>

      <nav className="nav">
        {NAV.map(n => (
          <button key={n.key} className={tab === n.key ? 'on' : ''}
            onClick={() => { switchTab(n.key); }}>
            <span>{n.icon}{n.key === 'estoque' && lowStock > 0 && <span className="nav-dot">{lowStock}</span>}</span>
            {n.label}
          </button>
        ))}
      </nav>

      {movModal && (
        <MovimentacaoModal produto={movModal.produto} tipo={movModal.tipo}
          onConfirm={async (payload) => {
            setMovModal(null);
            if (movModal.tipo === 'entrada') {
              await doSave(() => addEntrada(payload.produto_id, payload.quantidade), 'Estoque atualizado!');
            } else {
              await doSave(() => addSaida(payload.produto_id, payload.quantidade, payload.cliente_id), 'Venda registrada!');
            }
          }} onCancel={() => setMovModal(null)} />
      )}

      <Toast message={toast?.message} type={toast?.type} onClose={() => setToast(null)} />
      <ConfirmModal title={confirm?.title} message={confirm?.message} onConfirm={confirm?.onConfirm} onCancel={confirm?.onCancel} />
    </div>
  );
}
